import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, OnDestroy, OnInit} from '@angular/core';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';
import {WorkerStore} from '../../../../../../chat-sdk/src/api/worker';
import {Subscription} from 'rxjs';
import {IconsFolder} from "../../../../entities/enums";

// @todo chat move common to abstract class
@Component({
  selector: 'app-chat-reply-message',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatReplyMessageComponent implements OnInit, OnDestroy {
  @Input() message: Message = null;
  workerStore: WorkerStore = null;
  cdr: ChangeDetectorRef;

  subs: Subscription[] = [];

  constructor(
    cdr: ChangeDetectorRef
  ) {

    this.cdr = cdr;
  }

  ngOnInit() {
    this.workerStore = this.message.user ? this.message?.user?.getWorker() : null;

    if (this.workerStore) {
      this.subs.push(this.workerStore?.updateEvent.subscribe(() => {
        this.cdr.detectChanges();
      }));
    }

    this.message.registerOnUpdate((type) => {
      console.log('message update component', this.message, type);

      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.subs.length) {
      this.subs.forEach(item => item.unsubscribe());
    }
  }

  attachmentIcon(): {icon: string; folder: IconsFolder;} {
    const attachments = this.message.content.attachments;
    if (attachments.some(att => att.fileType() === 'image')) {
      return {icon: 'media-photo', folder: 'icons'};
    } else if (attachments.some(att => att.fileType() === 'video')) {
      return {icon: 'video-serv', folder: 'new-icons'};
    } else {
      return {icon: 'descr-serv', folder: 'new-icons'};
    }
  }
}
